import { useTranslation } from "react-i18next";
import { Title } from "../title/Title";

export const Footer = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();
    const email = t('contactUs.email')

    return (
        <footer className="bg-gradient-to-r from-green-200 py-6 to-green-600">
            <div className="container mx-auto px-4 text-center">
                <div className="flex flex-col items-center space-y-2">
                    <a
                        href={`mailto:${email}`}
                        className="text-white hover:text-gray-900 transition-colors"
                    >
                        {email}
                    </a>
                    <p className="text-white text-sm">
                        &copy; {currentYear} <Title noColours={true} />
                    </p>
                </div>
            </div>
        </footer>
    );
};
